module.exports = __webpack_public_path__ + "img/designer_apply.3bb871d2.png";